module.exports = __webpack_public_path__ + "img/vanossgaming.76cb7508.png";